// extracted by mini-css-extract-plugin
module.exports = {"descriptionContainer":"ExpandableDescription_descriptionContainer__eA7Sw","showLessButton":"ExpandableDescription_showLessButton__7O0WD"};